import { render, staticRenderFns } from "./EffectSidebar.vue?vue&type=template&id=d13d8d0e&lang=pug"
import script from "./EffectSidebar.vue?vue&type=script&lang=js"
export * from "./EffectSidebar.vue?vue&type=script&lang=js"
import style0 from "./EffectSidebar.vue?vue&type=style&index=0&id=d13d8d0e&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports